import useStyles from "../assets/styles/useStyles";
import logo from "../assets/logo.png";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Copyright from "../components/Copyright";
import React, {useState} from "react";
import {useNavigate} from "react-router";
import usePOST from "../hooks/usePOST";
import {withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

function ForgotPassword() {
    const [responsePost, sendPostRequest] = usePOST();
    const [error, setError] = useState({email: false});
    const [email, setEmail] = useState("");
    const [submittedEmail, setSubmittedEmail] = useState("")
    const [mailSent, setMailSent] = useState(false)
    const navigate = useNavigate();

    const classes = useStyles();

    const submitHandler = async (event) => {
        event.preventDefault();

        if (!email.includes('@')) {
            setError({email: true});
            return;
        }

        setMailSent(true)
        setSubmittedEmail(email)
        await sendPostRequest({
            id: 'forgotPassword',
            url: `/api/users/forgotPassword`,
            data: {
                email: email,
            },
            headers: {},
        });
    };

    return <div>
        <img src={logo} alt="Logo" style={{width: 100}}/>
        <Grid container className={classes.root}>
            <div className={classes.paper}>
                <Box mb={3}>
                    <Typography variant="h1" align="center"><b>MOT DE PASSE OUBLIÉ</b></Typography>
                </Box>
                <form onSubmit={submitHandler} className={classes.form}>
                    {mailSent && <Typography id="mail-confirmation" className={classes.confirm} align="center">
                        Si un compte est associé à l'adresse e-mail {submittedEmail},
                        un lien de réinitialisation du mot de passe vous sera envoyé par e-mail.
                    </Typography>}

                    <CssTextField
                        label="Adresse Email"
                        variant="outlined"
                        required
                        error={error.email}
                        fullWidth
                        margin="normal"
                        onChange={(event) => {
                            setEmail(event.target.value)
                        }}
                    />

                    <div style={{ textAlign: "right", marginTop: "8px" }}>
                        <Button
                            onClick={() => (
                                navigate('/signIn')
                            )}
                            color="primary"
                            size="small"
                            style={{ textTransform: "none" }}
                        >
                            Retourner à la page de connexion
                        </Button>
                    </div>
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",}}>
                        <Button type="submit" variant="contained" className={classes.submit}>
                            ENVOYER UN MAIL DE RÉCUPÉRATION
                        </Button>
                    </div>
                </form>
                <Box mt={5}>
                    <Copyright/>
                </Box>
            </div>
        </Grid>
    </div>
}

const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#FF9300',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FF9300',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: "20px",
            '& fieldset': {
                borderColor: '#FF9300',
            },
            '&:hover fieldset': {
                borderColor: '#FF9300',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9300',
            },
        },

    },
})(TextField);

export default ForgotPassword;